import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const DOMAIN = 'https://www.diginetworkad.net';

const SEO = ({
    title,
    description,
    canonical,
    type = 'website',
    image = `${DOMAIN}/logo512.png`
}) => {
    const location = useLocation();

    // Check if we're on an admin page
    const isAdminPage = location.pathname.startsWith('/admin');

    // Construct the canonical URL
    const url = canonical ? `${DOMAIN}${canonical}` : `${DOMAIN}${location.pathname}`;
    // Format the title with the site name
    const shouldAppendBrand = title && !title.includes('Digi Network');
    const siteTitle = title ? (shouldAppendBrand ? `${title} | Digi Network` : title) : 'Digi Network | Digital Marketing Agency';

    return (
        <Helmet>
            {/* Standard metadata tags */}
            <title>{siteTitle}</title>
            <meta name="description" content={description} />
            {isAdminPage ? (
                <meta name="robots" content="noindex, nofollow" />
            ) : (
                <meta name="robots" content="index, follow" />
            )}
            <link rel="canonical" href={url} />

            {/* OpenGraph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={siteTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={siteTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={image} />
        </Helmet>
    );
};

export default SEO;
